export default __webpack_public_path__ + "static/media/INTJ.3d1c6c09.svg";